module.exports = __webpack_public_path__ + "static/bundle-individual-d7d85a52cc513ff02c2e864ce591aff1.png";